import { useRouter } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'
import { Button } from '@/src/common/components/Button'
import { useSardine } from '@/src/services/Sardine'
import { useEffect } from 'react'
import { View, YStack } from 'tamagui'
import * as Components from '../components'
import * as E2E from '../e2e'

export function ApplicationInReviewScreen() {
  const router = useRouter()
  const { updateOptions } = useSardine()

  useEffect(() => {
    void updateOptions({ flow: 'application-in-review' })
  }, [updateOptions])

  return (
    <View flex={1} bg="$white1" testID={E2E.Config.Ids.View.InReview}>
      <Components.ApplicationScreen>
        <View px="$4">
          <Components.ApplicationScreen.Content title="You're almost done">
            <Components.FormHelpText>
              We are reviewing a few additional pieces of information. We will reach out to you in
              app or via email within 1-2 business days.
            </Components.FormHelpText>
          </Components.ApplicationScreen.Content>
        </View>
        <View px="$4">
          <YStack gap="$3" pt="$4" pb="$2">
            <Button
              title="Return Home"
              onPress={() => router.replace(Routes.Main.route)}
              testID={E2E.Config.Ids.Press.InReviewReturnHome}
            />
          </YStack>
        </View>
      </Components.ApplicationScreen>
    </View>
  )
}
